"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BrandedAppsFilters = /*#__PURE__*/function () {
  BrandedAppsFilters.$inject = ["EventEmitter"];
  /* @ngInject */
  function BrandedAppsFilters(EventEmitter) {
    _classCallCheck(this, BrandedAppsFilters);
    this.EventEmitter = EventEmitter;
  }
  return _createClass(BrandedAppsFilters, [{
    key: "$onChanges",
    value: function $onChanges(_ref) {
      var filters = _ref.filters;
      if (!filters.currentValue) {
        return;
      }
      return this.filters = Object.assign({}, this.filters);
    }
  }, {
    key: "setFilterValue",
    value: function setFilterValue(filter, value) {
      return this.onSetFilterValue(this.EventEmitter({
        filter: filter,
        value: value
      }));
    }
  }, {
    key: "setOrResetFilterValue",
    value: function setOrResetFilterValue(filter, value) {
      var newValue = this.filters[filter].value === value ? null : value;
      return this.setFilterValue(filter, newValue);
    }
  }, {
    key: "resetFilter",
    value: function resetFilter(filter) {
      return this.onSetFilterValue(this.EventEmitter({
        filter: filter,
        value: null
      }));
    }
  }]);
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-filters', []).component('brandedAppFilters', {
  templateUrl: '/src/angular/components/branded-app/branded-app-filters/branded-app-filters.html',
  bindings: {
    filters: '<',
    onSetFilterValue: '&'
  },
  controller: BrandedAppsFilters
}).name;